import {
  ESdChangeReason,
  ICRUDFormDiMetadata,
  ICRUDFormField,
  IDisplayItem,
  IDisplayItemProperty,
  IFormSection
} from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../../shared/pure-sd";

enum EFormChildrenTreeItemType {
  Form = 1,
  Section = 2,
  Header = 3,
  Row = 4,
  FieldCell = 5,
  Label = 6,
  Input = 7
}

interface IFormTreeDataNode {
  id: number;
  title: string;
  expanded: boolean;
  children?: IFormTreeDataNode[];
}

interface IFormChildrenTreeProps {
  formDi: IDisplayItem;
}

interface IFormChildrenTreeState {}

class FormChildrenTree extends PureSdComponent<IFormChildrenTreeProps & IWithSDProps, IFormChildrenTreeState> {
  constructor(props: IFormChildrenTreeProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  private getMetadata = (di: IDisplayItem): ICRUDFormDiMetadata | null => {
    if (di.item.name !== "Form") {
      return null;
    }

    const metadataProp: IDisplayItemProperty | undefined = di.item.properties.find(
      (x: IDisplayItemProperty): boolean => x.name === "metadata"
    );

    if (!metadataProp?.symbol?.fixedValue) {
      return null;
    }

    return JSON.parse(metadataProp.symbol.fixedValue as string) as ICRUDFormDiMetadata;
  };

  private getTreeDataFromMetadata = (metadata: ICRUDFormDiMetadata | null): IFormTreeDataNode[] => {
    const treeData: IFormTreeDataNode[] = [];

    if (!metadata) {
      return treeData;
    }

    const mainNode: IFormTreeDataNode = {
      id: this.props.formDi.id,
      title: "Form",
      expanded: true,
      children: []
    };

    metadata.sections.forEach((section: IFormSection, index: number) => {
      const sectionNode: IFormTreeDataNode = {
        id: parseInt(section.id, 10),
        title: section.title ?? `Section ${index + 1}`,
        expanded: true,
        children: []
      };

      sectionNode.children?.push({
        id: parseInt(section.id, 10),
        title: "Header",
        expanded: true
      });

      section.items.forEach((field: ICRUDFormField) => {
        sectionNode.children?.push({
          id: parseInt(field.id, 10),
          title: field.name,
          expanded: true
        });
      });

      mainNode.children?.push(sectionNode);
    });

    treeData.push(mainNode);
    return treeData;
  };

  private getTreeData = (): IFormTreeDataNode[] => {
    const mainNode: IFormTreeDataNode = {
      id: EFormChildrenTreeItemType.Form,
      title: "Form",
      expanded: true,
      children: [
        {
          id: EFormChildrenTreeItemType.Section,
          title: "Sections",
          expanded: true,
          children: [
            {
              id: EFormChildrenTreeItemType.Header,
              title: "Headers",
              expanded: true
            },
            {
              id: EFormChildrenTreeItemType.Row,
              title: "Rows",
              expanded: true,
              children: [
                {
                  id: EFormChildrenTreeItemType.FieldCell,
                  title: "Field Cells",
                  expanded: true,
                  children: [
                    {
                      id: EFormChildrenTreeItemType.Label,
                      title: "Labels",
                      expanded: true
                    },
                    {
                      id: EFormChildrenTreeItemType.Input,
                      title: "Inputs",
                      expanded: true
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    };

    return [mainNode];
  };

  private highlightDisplayItems = (id: EFormChildrenTreeItemType): void => {
    if (id === EFormChildrenTreeItemType.Form) {
      this.props.sd.highlightHoveredItem(this.props.formDi.id.toString());
      return;
    }
  };

  private clickDisplayItems = (id: EFormChildrenTreeItemType): void => {
    if (id === EFormChildrenTreeItemType.Form) {
      this.props.sd.setSelectedDisplayItem(this.props.formDi.id.toString());
      return;
    }
  };

  private onClickEditForm = () => {
    this.props.sd.setIsWizardForFormOpen(true);
    this.props.sd.setTargetKuikaIdForFormWizard(this.props.formDi.id.toString());
    this.props.sd.setMetadataForFormWizard(this.getMetadata(this.props.formDi));
  };

  render() {
    // const metadata: ICRUDFormDiMetadata | null = this.getMetadata(this.props.formDi);
    // const treeData: IFormTreeDataNode[] = this.getTreeData();
    // const sd = this.props.sd.getScreenDesign();

    return (
      <div className="form-children-tree">
        <button data-testid="editFormButton" className="form-children-tree--button" onClick={this.onClickEditForm}>
          Edit Form
        </button>

        {/* <div className="kuika_FormChildrenContainer">
          <button
            onClick={() => this.clickDisplayItems(EFormChildrenTreeItemType.Form)}
            className={classNames({
              kuika_NonSelectedNodeDi: true,
              kuika_SelectedNodeDi: this.props.sd.getSelectedDisplayItem(sd)?.item.name === "Form"
            })}
            onMouseEnter={() => this.highlightDisplayItems(EFormChildrenTreeItemType.Form)}
            onMouseLeave={() => this.props.sd.highlightHoveredItem(SpecialDIIds.rootDI.toString())}
          >
            Form
          </button>
          <button
            className="kuika_NonSelectedNodeDi"
            style={{
              width: "calc(100% - 25px)"
            }}
          >
            Sections
          </button>
          <button
            className="kuika_NonSelectedNodeDi"
            style={{
              width: "calc(100% - 50px)"
            }}
          >
            Headers
          </button>
          <button
            className="kuika_NonSelectedNodeDi"
            style={{
              width: "calc(100% - 50px)"
            }}
          >
            Rows
          </button>
          <button
            className="kuika_NonSelectedNodeDi"
            style={{
              width: "calc(100% - 75px)"
            }}
          >
            Field Cells
          </button>
          <button
            className="kuika_NonSelectedNodeDi"
            style={{
              width: "calc(100% - 100px)"
            }}
          >
            Labels
          </button>
          <button
            className="kuika_NonSelectedNodeDi"
            style={{
              width: "calc(100% - 100px)"
            }}
          >
            Inputs
          </button>
        </div> */}
      </div>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return (
      changeReason === ESdChangeReason.ChangeSelectedDiByCanvasFrame ||
      changeReason === ESdChangeReason.ChangeSelectedDiByTools
    );
  };
}

const formChildrenTree = withSD<IFormChildrenTreeProps>(FormChildrenTree);
export { formChildrenTree as FormChildrenTree };
